import { createAction, createStandardAction } from 'typesafe-actions';
import { ErrorBoundaryError } from './Types';

export const setError = createStandardAction('@@error-boundary/SET_ERROR')<ErrorBoundaryError>();
export const sendErrorRequest = createAction('@@error-boundary/SEND_ERROR_REQUEST');
export const sendErrorSuccess = createAction('@@error-boundary/SEND_ERROR_SUCCESS');
export const sendErrorFailure = createAction('@@error-boundary/SEND_ERROR_FAILURE');
